import React from "react"

import QuizzLayout from "../components/quizz-layout"

import { QuizzProvider } from "@bit/dweez.perso.quizz.contexts"

import InviteReset from "./invite-reset"
import QuizzLoader from "./loader"
import ResetButton from "@bit/dweez.perso.quizz.reset-button"
import Infos from "./infos"

export default props => {
  const { quizz, hasLocalStorage, showStepper, typeViz } = props
  const { questionnaire, parties } = quizz
  return (
    <QuizzLayout quizzTitle={questionnaire.title} {...props}>
      <QuizzProvider
        data={{ questionnaire, parties }}
        hasLocalStorage={hasLocalStorage}
        showStepper={showStepper}
        typeViz={typeViz}
      >
          <main>
            <InviteReset />
            <QuizzLoader />
            <div className="tools-bar" style={{height: "31px", minHeight: "31px", textAlign: "center"}}>
              <ResetButton />
            </div>
          </main>
          <Infos />
      </QuizzProvider>
    </QuizzLayout>
  )
}
